export default {
    api: {
        url: 'http://localhost:5051/hrm/api/v1/',
        mode: 'cors'
    }
}
